import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';


const Club = () => {
  return (
    <>
      <Box height={100} />

      <Grid container spacing={0} alignItems="center" justify="center">
        <Grid item xs={2} />
          <Grid item xs={8}>
            <Card>
              <CardHeader title='学校社团主页面 (创建中...)'/>
              <CardContent>
                <Box textAlign={'center'}>
                  <Typography>
                    学校社团旨在为学生提供一个展示才华、发展兴趣和建立友谊的平台。社团活动丰富多彩，包括艺术、体育、科技等多个领域，旨在培养学生的团队合作精神和领导能力。通过参与社团，学生可以在课外活动中找到归属感，提升自信心，并为未来的学习和生活打下坚实的基础。

                  </Typography>
                </Box>
              </CardContent>
              </Card>
          </Grid> 
        <Grid item xs={2} />
      </Grid>
      
      <Box height={80} />
    </>
  )
}

export default Club